var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner--sides"},[_c('h3',{staticClass:"prompt"},[_vm._v(_vm._s(_vm.stakeholderPrompt1))]),_vm._v(" "),_c('lookup-form'),_vm._v(" "),_c('opt-in-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }